import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { WeverCoreContext } from "../../services/core";

/**
 * Translate Components helper
 *
 * @param {Object} props
 */
var Translate = function Translate(_ref) {
  var from = _ref.from;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var keys = Object.keys(from);
  var localeWord = from[locale] || from[keys[0]];
  return /*#__PURE__*/React.createElement(React.Fragment, null, localeWord);
};
Translate.propTypes = {
  id: PropTypes.object
};
export default Translate;